import mock from '../mocks/coordination';

export function useCoordinaion() {
  const coordinators = mock;
  return coordinators;
};